import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BUSINESS_CONST } from 'src/app/shared/constants/business.constants';
import { OpEnum } from 'src/app/shared/enums/op.enum';
import { LogDeviceModel } from 'src/app/shared/models/log-device.model';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { ConfigurationService } from 'src/app/shared/services/configuration/configuration.service';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { FirmlyApprovedService } from 'src/app/shared/services/firmly-approved/firmly-approved.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { BitacoraService } from '../../../shared/services/bitacora/bitacora.service';
import { StringHelperService } from '../../../shared/services/helpers/string-helper.service';
import { DaliService } from '@dali/tagger-ng8';
import { EVENT as EVENT_FA_TC, PAGEVIEW as PAGEVIEW_FA, CHANNEL as CHANNEL_FA, COUNTRY as COUNTRY_FA, BUSINNESS as BUSINNESS_FA, ENVIRONMENT as ENVIRONMENT_FA, FAMILY as FAMILY_FA, SUBFAMILY as SUBFAMILY_FA, PRODUCT as PRODUCT_FA, } from 'src/app/shared/constants/dali-fa-tc.constants';
import { TaggingService } from 'src/app/shared/services/tagging/tagging.service';
import { ChannelCommunicatorService } from 'src/app/shared/services/communicator/channel-communicator/channel-communicator.service';
var AddressConfigTcComponent = /** @class */ (function () {
    function AddressConfigTcComponent(copyService, headerService, abreCuentasService, parametersService, navigationService, stringHelperService, formBuilder, configurationService, bitacoraService, firmlyApprovedService, channelCommunicatorService, taggingService, daliService) {
        this.copyService = copyService;
        this.headerService = headerService;
        this.abreCuentasService = abreCuentasService;
        this.parametersService = parametersService;
        this.navigationService = navigationService;
        this.stringHelperService = stringHelperService;
        this.formBuilder = formBuilder;
        this.configurationService = configurationService;
        this.bitacoraService = bitacoraService;
        this.firmlyApprovedService = firmlyApprovedService;
        this.channelCommunicatorService = channelCommunicatorService;
        this.taggingService = taggingService;
        this.daliService = daliService;
        this.showOptions = false;
        this.back = '';
        this.emptyAddress = {
            address: '',
            addressInput: '',
            city: {
                city_code: '',
                country_code: '',
                description: '',
                province_code: undefined,
            },
            detail: '',
        };
        this.headerService.show(true, true, true);
        this.formGroup = this.formBuilder.group({});
        this.devicePrint = new LogDeviceModel();
        // this.listAddress = [{
        //   label: this.copyService.copies.address_config_tc_add_address,
        //   elementId: 3,
        //   checked: false,
        // }];
        this.listAddress = [];
    }
    AddressConfigTcComponent.prototype.ngOnInit = function () {
        this.sendTagging('init');
        if (this.taggingService.isFirmlyAprovedMono()) {
            this.sendAddressConfigPageLoad();
        }
        var regexp = new RegExp(/^(?![ ])(?!.*[ ]{2})(?!.*[ ]$)[Ññ\w-#/., ]+$/);
        var selectedOccupation = this.abreCuentasService.getOccupationSelected();
        var selectedCiiu = this.abreCuentasService.getCiiuSelected();
        this.companyAddress = this.abreCuentasService.getOfficeInfo((selectedOccupation.id || '') + '');
        var additionalAddress = this.abreCuentasService.getAddressInfoConfigTc();
        this.homeAddress = this.abreCuentasService.getContactInfo();
        var productSelected = this.abreCuentasService.getproductSelected();
        var userAddressListSelection = this.abreCuentasService.getAddtionalAddressConfigTcList();
        this.addressInfo = additionalAddress === undefined ? this.emptyAddress : additionalAddress;
        this.selectedCity = this.addressInfo.city;
        this.formGroup = new FormGroup({
            'input-value-address': new FormControl(this.addressInfo.address, [
                Validators.required,
                Validators.minLength(4),
                Validators.maxLength(40),
                Validators.pattern(regexp),
            ]),
            'input-value-city': new FormControl(this.addressInfo.city.description, [Validators.required]),
            'input-value-addressDetail': new FormControl(this.addressInfo.detail, [
                Validators.minLength(0),
                Validators.maxLength(40),
            ]),
        });
        this.product_type = productSelected ? productSelected.product_type : '';
        this.previous();
        this.navigationService.pageLoadTag(false, ['', '', 'pv226', '']);
        if (userAddressListSelection === undefined) {
            if (this.companyAddress && this.companyAddress.address && this.companyAddress.address.address) {
                this.listAddress.unshift({
                    label: this.companyAddress.address.address + " (trabajo)",
                    elementId: 2,
                    checked: false,
                });
            }
            if (this.homeAddress && this.homeAddress.address && this.homeAddress.address.address) {
                this.listAddress.unshift({
                    label: this.homeAddress.address.address + " (casa)",
                    elementId: 1,
                    checked: false,
                });
            }
            if (selectedOccupation.name === 'Empleado' ||
                selectedOccupation.name === 'Independiente' && selectedCiiu.ciiu !== '090' && JSON.stringify(this.addressInfo) === '{}') {
                this.addressInfo = this.companyAddress.address || '';
            }
            if (this.companyAddress && this.companyAddress.address.address === this.addressInfo.address) {
                this.optionConfigAddress = this.listAddress.find(function (data) {
                    data.checked = data.elementId === 2;
                    return data.checked;
                });
            }
            else if (!this.addressInfo || !this.addressInfo.address || this.homeAddress.address.address === this.addressInfo.address) {
                this.addressInfo = this.homeAddress.address;
                this.optionConfigAddress = this.listAddress.find(function (data) {
                    data.checked = data.elementId === 1;
                    return data.checked;
                });
            }
            else {
                this.optionConfigAddress = this.listAddress.find(function (data) {
                    data.checked = data.elementId === 3;
                    return data.checked;
                });
            }
        }
        else {
            this.listAddress = userAddressListSelection;
            var addressChecked = { value: '' };
            addressChecked.value = this.listAddress.find(function (address) {
                return address.checked === true ? address : '';
            });
            this.updateSelection(addressChecked);
        }
        if ((this.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC || this.product_type === BUSINESS_CONST.PRODUCT_TYPE_REVOLVING
            || this.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE) &&
            (this.firmlyApprovedService.isEmpty() &&
                this.firmlyApprovedService.getOfferType_Channel() !== 'En_firme')) {
            this.pco = this.abreCuentasService.getPcoModel().solicitation_status.status_code;
        }
        this.options = this.parametersService.getSetting(OpEnum.CITY_LIST);
        this.options2 = this.options;
        this.optionsFilter = this.options.map(function (option) { return ({ data: option, value: option.description }); });
    };
    /**
     * Summary Address entry change event, error validation
     *
     * @param {*} event
     * @memberof AddressConfigTcComponent
     */
    AddressConfigTcComponent.prototype.reactiveInputChangeAddress = function () {
        this.controladdress = this.formGroup.controls['input-value-address'];
        this.addressInput = this.controladdress.value;
        this.controladdress.setValue(this.controladdress.value.replace(/[^A-Za-z0-9\s#\-.]/g, '').replace(/\s{2,}/g, ' '));
        this.updateAddresInfoConfigTc();
        this.abreCuentasService.setAddressInfoConfigTc(this.addressInfo);
    };
    /**
     * Summary Event for select a option for list city selected, and set value in Input
     *
     * @param {CityModel} option
     * @memberof AddressConfigTcComponent
     */
    AddressConfigTcComponent.prototype.selectOption = function (event) {
        if (event.value) {
            this.selectedCity = event.value;
            this.showOptions = true;
            this.addressInfo.city = this.selectedCity;
            this.formGroup.controls['input-value-city'].setValue(event.value.description);
            this.updateAddresInfoConfigTc();
            this.abreCuentasService.setAddressInfoConfigTc(this.addressInfo);
        }
        else {
            this.selectedCity = {
                city_code: '',
                country_code: '',
                province_code: 0,
                description: '',
            };
        }
    };
    /**
     * Update addressInfo variable
     *
     * @memberof updateAddresInfoConfigTc
     */
    AddressConfigTcComponent.prototype.updateAddresInfoConfigTc = function () {
        this.addressInfo = {
            city: this.addressInfo.city,
            addressInput: this.addressInput,
            address: this.formGroup.value['input-value-address'],
            detail: this.formGroup.value['input-value-addressDetail'] || '',
        };
    };
    /**
     * Summary event for select a option address
     *
     * @param {*} $event
     * @memberof AddressConfigTcComponent
     */
    AddressConfigTcComponent.prototype.selectRadioAddress = function (event) {
        event.value.checked = true;
        this.optionConfigAddress = event.value;
        if (this.addressInfo.address !== '') {
            this.updateAddressCheckedValue(event);
            this.abreCuentasService.setAddtionalAddressConfigTcList(this.listAddress);
        }
        else {
            this.updateSelection(event);
        }
    };
    AddressConfigTcComponent.prototype.updateAddressCheckedValue = function (event) {
        var _this = this;
        var copyListAddress = this.listAddress;
        copyListAddress.forEach(function (address) {
            if (address.elementId === event.value.elementId) {
                event.value.elementId === 1 ? _this.addressInfo = _this.homeAddress.address : _this.addressInfo = _this.companyAddress.address;
                address.checked = true;
            }
            else {
                address.checked = false;
            }
        });
        this.showOptions = event.value.elementId === 3 ? true : false;
        this.listAddress = copyListAddress;
    };
    /**
     * Updates address reference to selected config option
     *
     * @memberof AddressConfigTcComponent
     */
    AddressConfigTcComponent.prototype.updateSelection = function (event) {
        switch (event.value.elementId) {
            case 1:
                this.optionConfigAddress = event.value;
                this.addressInfo = this.homeAddress.address;
                this.showOptions = false;
                break;
            case 2:
                this.optionConfigAddress = event.value;
                this.addressInfo = this.companyAddress.address;
                this.showOptions = false;
                break;
            case 3:
                this.optionConfigAddress = event.value;
                this.showOptions = true;
                break;
            default:
                break;
        }
    };
    AddressConfigTcComponent.prototype.nextCreditCard = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var type, bitacoraEvent, body;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                type = this.optionConfigAddress.elementId;
                bitacoraEvent = "product_addres_" + (type === 1 ? 'home' : type === 2 ? 'work' : 'other');
                this.bitacoraService.saveDataInBitacora(bitacoraEvent);
                this.configurationService.sendCardInformation();
                body = {
                    data: {
                        agency: this.abreCuentasService.getAgencySelected(),
                        phone: this.abreCuentasService.getContactInfo().mobile_number,
                    },
                };
                this.configurationService.offersConfig(body).then(function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                    return tslib_1.__generator(this, function (_a) {
                        if (!response) {
                            return [2 /*return*/];
                        }
                        if (response.status === 500) {
                            this.navigationService.navigateToGeneralInformation('500');
                            return [2 /*return*/];
                        }
                        return [2 /*return*/];
                    });
                }); }).catch(function () { return _this.navigationService.navigateToGeneralInformation('500'); });
                return [2 /*return*/];
            });
        });
    };
    AddressConfigTcComponent.prototype.nextAccounts = function () {
        var nextStep = '200';
        if (this.pco !== undefined) {
            nextStep = this.pco === 'PCO02' ? '201' : '200';
        }
        if (this.abreCuentasService.viewOptionMultiProduct) {
            var productList = this.abreCuentasService.getProductsSelects();
            if (!this.firmlyApprovedService.isEmpty()
                && this.firmlyApprovedService.getOfferType_Channel() === 'En_firme'
                && !this.abreCuentasService.getPayDayProductSelected().selectedProduct) {
                this.nextMulti();
            }
            else if (productList.find(function (find) { return find.product_type == BUSINESS_CONST.PRODUCT_TYPE_TC; })) {
                this.configurationService.sendCardInformation();
            }
            else {
                this.nextMulti();
            }
        }
        else {
            this.navigationService.nextStep(nextStep);
        }
    };
    /**
     * Persist data and redirect to next webview
     *
     * @memberof AddressConfigTcComponent
     */
    AddressConfigTcComponent.prototype.next = function () {
        this.sendTagging('next', 'bottom', '2');
        if (this.taggingService.isFirmlyAprovedMono()) {
            this.sendContinueButtonEvent();
        }
        this.abreCuentasService.setAddtionalAddressConfigTcList(this.listAddress);
        if (this.showOptions) {
            this.updateAddresInfoConfigTc();
        }
        this.abreCuentasService.setAddressInfoConfigTc(this.addressInfo);
        if (this.product_type === BUSINESS_CONST.PRODUCT_TYPE_SAVINGS ||
            this.product_type === BUSINESS_CONST.PRODUCT_TYPE_PAYROLL ||
            this.product_type === BUSINESS_CONST.PRODUCT_TYPE_REVOLVING ||
            this.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE ||
            this.product_type === BUSINESS_CONST.MULTI ||
            this.product_type === BUSINESS_CONST.PRODUCT_TYPE_LOAN ||
            this.pco === 'PCO02') {
            this.nextAccounts();
        }
        else {
            this.nextCreditCard();
        }
    };
    /**
     * Summary validates forms validity
     *
     * @returns
     * @memberof AddressConfigTcComponent
     */
    AddressConfigTcComponent.prototype.isvalid = function () {
        var valid = false;
        if (this.showOptions) {
            valid = this.formGroup.valid;
        }
        else if (this.optionConfigAddress) {
            valid = true;
        }
        else {
            valid = false;
        }
        return valid;
    };
    /**
     * validar enviar con multi producto
     */
    AddressConfigTcComponent.prototype.nextMulti = function () {
        if (this.abreCuentasService.haveLoan) {
            this.navigationService.nextStep('200');
        }
        else {
            this.navigationService.nextStep(this.navigationService.nextMulti(this.abreCuentasService.getProductsSelects()));
        }
    };
    AddressConfigTcComponent.prototype.previous = function () {
        this.back = '';
        if (!this.abreCuentasService.viewOptionMultiProduct) {
            if (this.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC) {
                if (!this.navigationService.isCardDuality()) {
                    this.back = '200';
                }
                else {
                    this.back = '201';
                }
            }
            else {
                this.back = 'default';
            }
        }
        else if (this.abreCuentasService.haveLoan) {
            this.back = '202';
        }
    };
    /* ------------- Taggeo ------------- */
    /* ------------ Taggeo - PageLoad ------------ */
    AddressConfigTcComponent.prototype.sendAddressConfigPageLoad = function () {
        var isApp = this.channelCommunicatorService.getChannelId() === '141';
        var changes = [
            {
                path: PAGEVIEW_FA.pv9pageName.path,
                value: (isApp ? CHANNEL_FA.superapp : CHANNEL_FA.homeBanking) + ":" + COUNTRY_FA.co + ":" + BUSINNESS_FA.pf + ":" + ENVIRONMENT_FA.loggeado + ":" + FAMILY_FA.services + ":" + SUBFAMILY_FA.request + ":" + PRODUCT_FA.request + ":" + PAGEVIEW_FA.pv9pageName.value,
            },
            {
                path: PAGEVIEW_FA.pv9pageFamily.path,
                value: PAGEVIEW_FA.pv9pageFamily.value,
            },
            {
                path: PAGEVIEW_FA.pv9subFamily.path,
                value: PAGEVIEW_FA.pv9subFamily.value,
            },
            {
                path: PAGEVIEW_FA.pv9pageAction.path,
                value: PAGEVIEW_FA.pv9pageAction.value,
            },
            {
                path: PAGEVIEW_FA.pv9pageid.path,
                value: AddressConfigTcComponent.name,
            },
            {
                path: PAGEVIEW_FA.pv9transactionName.path,
                value: "" + PAGEVIEW_FA.pv9transactionName.value.slice(0, -2) + this.taggingService.getProductFlow(),
            },
            {
                path: PAGEVIEW_FA.pv9transactionTransactionStep.path,
                value: PAGEVIEW_FA.pv9transactionTransactionStep.value,
            },
        ];
        this.taggingService.addCommonPageChanges(changes);
        this.daliService.pageLoad(changes);
    };
    /* -------------- Taggeo - Events ------------- */
    AddressConfigTcComponent.prototype.sendBackButtonEvent = function () {
        this.sendTagging('prev', 'bottom', '1');
        if (!this.taggingService.isFirmlyAprovedMono()) {
            return;
        }
        var data = [
            {
                path: EVENT_FA_TC.pv9E1setData.pv9E1transactionTransactionStep.path,
                value: EVENT_FA_TC.pv9E1setData.pv9E1transactionTransactionStep.value,
            },
            {
                path: EVENT_FA_TC.pv9E1setData.pv9E1transactionName.path,
                value: "" + EVENT_FA_TC.pv9E1setData.pv9E1transactionName.value.slice(0, -2) + this.taggingService.getProductFlow(),
            },
        ];
        var event = {
            category: {
                module: EVENT_FA_TC.customCategory.module.body,
                type: EVENT_FA_TC.customCategory.type.button,
                position: EVENT_FA_TC.customCategory.position.center,
            },
            action: EVENT_FA_TC.customAction.click,
            label: EVENT_FA_TC.pv9E1customLabel,
        };
        this.daliService.trackEvent(event, data);
    };
    AddressConfigTcComponent.prototype.sendContinueButtonEvent = function () {
        var data = [
            {
                path: EVENT_FA_TC.pv9E2setData.pv9E2transactionTransactionStep.path,
                value: EVENT_FA_TC.pv9E2setData.pv9E2transactionTransactionStep.value,
            },
            {
                path: EVENT_FA_TC.pv9E2setData.pv9E2transactionName.path,
                value: "" + EVENT_FA_TC.pv9E2setData.pv9E2transactionName.value.slice(0, -2) + this.taggingService.getProductFlow(),
            },
        ];
        var event = {
            category: {
                module: EVENT_FA_TC.customCategory.module.body,
                type: EVENT_FA_TC.customCategory.type.button,
                position: EVENT_FA_TC.customCategory.position.center,
            },
            action: EVENT_FA_TC.customAction.click,
            label: EVENT_FA_TC.pv9E2customLabel,
        };
        this.daliService.trackEvent(event, data);
    };
    AddressConfigTcComponent.prototype.sendTagging = function (value, position, event) {
        var page = '17';
        var extras = {
            pageValue: 'AddressConfigTc',
        };
        this.taggingService.sendTaggValues(value, page, position, event, extras);
    };
    return AddressConfigTcComponent;
}());
export { AddressConfigTcComponent };
